<template>
    <div class="review--block" id="review-resume">
        <div class="review--block--header" @click="() => { this.$emit('toggled', { }) }">
            <div class="review--block--header--title">
                <div>
                    Riepilogo
                </div>
            </div>
            <div class="review--block--header--checked" v-html="checked"></div>
        </div>
        <div class="review--block--body" v-if="opened">
            <div class="review--block--body--header">
                <div class="review--block--body--header--title">
                    La tua proposta
                </div>
                <!--<div class="review--block--body--header--icon" v-html="info"></div>-->
                <div class="review--block--body--header--subtitle">
                    I prezzi e le disponibilità di questa proposta sono soggetti a conferma.
                </div>
            </div>
            <b-row>
                <b-col md="6" lg="5">
                    <div class="review--block--body--content">
                        <div class="review--resume--item" v-for="(service) in quote.services" v-bind:key="service.service_index">

                            <!-- review resume overnights -->
                            <div class="review--resume--item--service" v-if="service.type == 'overnight'">
                                <div class="review--resume--item--icon" v-html="bedding"></div>
                                <div class="review--resume--item--content" :set="selected_id = review_steps[service.service_index].selected">
                                    {{ service.details.title }}
                                    <!--<div v-for="(item,index) in service.details.hotels" v-bind:key="_uid + index">
                                        <div v-if="index == selected_id">
                                            {{ item.property_name }}
                                        </div>
                                    </div>-->
                                </div>
                                <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                    € {{ service.public_data.public_price }}
                                </div>
                            </div>

                            <!-- review resume package -->
                            <div class="review--resume--item--service" v-if="service.type == 'package'">
                              <div class="review--resume--item--icon" v-html="bedding"></div>
                              <div class="review--resume--item--content" :set="selected_id = review_steps[service.service_index].selected">
                                {{ service.details.title }}
                                <!--<div v-for="(item,index) in service.details.hotels" v-bind:key="_uid + index">
                                    <div v-if="index == selected_id">
                                        {{ item.property_name }}
                                    </div>
                                </div>-->
                              </div>
                              <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                € {{ service.public_data.public_price }}
                              </div>
                            </div>

                            <!-- review resume flights -->
                            <div class="review--resume--item--service" v-if="service.type == 'flight'">
                                <div class="review--resume--item--icon" v-html="airplane"></div>
                                <div class="review--resume--item--content">
                                    {{ service.details.title }}
                                    <!--<div v-for="(item,index) in service.details.itineraries" v-bind:key="_uid + index">
                                        <div v-if="index == review_steps[service.service_index].selected">
                                            {{ iataAirportToName(item.segments[0].departure.iataCode) }} - {{ iataAirportToName(item.segments[item.segments.length-1].arrival.iataCode) }}
                                        </div>
                                    </div>-->
                                </div>
                                <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                    € {{ service.public_data.public_price }}
                                </div>
                            </div>

                            <!-- review resume transfers -->
                            <div class="review--resume--item--service" v-if="service.type == 'transfer'">
                                <div class="review--resume--item--icon" v-html="bus"></div>
                                <div class="review--resume--item--content">
                                    {{ service.details.title }}
                                    <!--<div v-for="(item,index) in service.details.transfers" v-bind:key="_uid + index">
                                        <span v-if="item.from != ''">{{ item.from }} - {{ item.to }}</span>
                                    </div>-->
                                </div>
                                <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                    € {{ service.public_data.public_price }}
                                </div>
                            </div>

                            <!-- review resume generics -->
                            <div class="review--resume--item--service" v-if="service.type == 'generic'">
                                <div class="review--resume--item--icon" v-html="star"></div>
                                <div class="review--resume--item--content" v-html="service.details.title"></div>
                                <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                    € {{ service.public_data.public_price }}
                                </div>
                            </div>

                            <!-- review resume insurances -->
                            <div class="review--resume--item--service" v-if="service.type == 'insurance'">
                                <div class="review--resume--item--icon" v-html="shield"></div>
                                <div class="review--resume--item--content" v-html="service.details.title"></div>
                                <div class="review--resume--item--price" v-if="service.public_data.public_price > 0">
                                    € {{ service.public_data.public_price }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="review--resume--total">
                        <div class="label">
                            Totale
                        </div>
                        <div class="content">
                            € {{ quote.details.grand_total }}
                        </div>
                    </div>

                    <div class="review--resume--item mt-2 text-center">
                        Tutti i prezzi indicati sono complessivi, inclusi tutti i partecipanti.
                        <br>
                        Le richieste che invii dopo le 17 verranno lavorate il giorno successivo.
                    </div>

                </b-col>
                <b-col md="6" lg="7">
                    <div class="review--block--footer">

                        <!-- review_state: expired-->
                        <div v-if="quote.details.review_state == 'expired'" class="review--state--expired">
                            <p>
                                <strong>Questa proposta non è più valida.</strong>
                                Desideri chiederne un aggiornamento?
                            </p>
                            <button-with-icon
                                class="btn--light" 
                                variant="light" 
                                text="Richiedi" 
                                :icon="chevron_right" 
                                :disabled="!can_submit" 
                                :clicked="() => {
                                    this.$bvModal.show('edit-request-modal')
                                }"
                            />
                            <b-modal id="edit-request-modal" title="Desideri richiedere un aggiornamento di questa Proposta?" size="lg" hide-footer>
                                <b-form-group label="Indica la richiesta di riattivazione ed eventuali modifiche.">
                                    <b-form-textarea
                                        ref="user_changes_request"
                                        id="user_changes_request"
                                        v-model="user_changes_request"
                                        placeholder="Desidero riattivare questa proposta"
                                    ></b-form-textarea>
                                </b-form-group>
                                <button-with-icon
                                    variant="cta" 
                                    text="Continua"
                                    :disabled="user_changes_request == ''"
                                    :icon="chevron_right" 
                                    :clicked="() => {
                                        this.$bvModal.hide('edit-request-modal')
                                        $emit('send_to_api', {
                                            user_changes_request: this.user_changes_request,
                                        })
                                    }"
                                />                                
                            </b-modal>
                        </div>
                        
                        <!-- review_state: declined-->
                        <div v-if="quote.details.review_state == 'declined'" class="review--state--declined">
                            <p>
                                <strong>Hai già richiesto modifiche a questa Proposta.</strong>
                                Appena la nuova Proposta sarà online riceverai un'email di notifica. Controlla la tua email di frequente.
                            </p>
                        </div>

                        <!-- review_state: accepted-->
                        <div v-if="quote.details.review_state == 'accepted'" class="review--state--accepted">
                            <p>
                                <strong>Hai già chiesto la pubblicazione di questa Proposta.</strong>
                                La pubblicazione sul sito, che ti permette di prenotare il viaggio, avviene nel giro di poche ore e ti viene notificata per email.
                                Controlla la tua posta elettronica o contattaci per chiarimenti.
                            </p>
                        </div>
                        
                        <!-- review_state: rejected-->
                        <div v-if="quote.details.review_state == 'rejected'" class="review--state--rejected">
                            <p>
                                <strong>
                                    Avevi rifiutato questa Proposta in passato.
                                </strong>
                                Desideri chiederne un aggiornamento?
                            </p>
                            <button-with-icon
                                class="btn--light" 
                                variant="light" 
                                text="Richiedi" 
                                :icon="chevron_right" 
                                :disabled="!can_submit" 
                                :clicked="() => {
                                    this.$bvModal.show('edit-request-modal')
                                }"
                            />
                            <b-modal id="edit-request-modal" title="Desideri richiedere un aggiornamento di questa Proposta?" size="lg" hide-footer>
                                <b-form-group label="Indica la richiesta di riattivazione ed eventuali modifiche.">
                                    <b-form-textarea
                                        ref="user_changes_request"
                                        id="user_changes_request"
                                        v-model="user_changes_request"
                                        placeholder="Desidero riattivare questa proposta"
                                    ></b-form-textarea>
                                </b-form-group>
                                <button-with-icon
                                    variant="cta" 
                                    text="Continua"
                                    :disabled="user_changes_request == ''"
                                    :icon="chevron_right" 
                                    :clicked="() => {
                                        this.$bvModal.hide('edit-request-modal')
                                        $emit('send_to_api', {
                                            user_changes_request: this.user_changes_request,
                                        })
                                    }"
                                />                                
                            </b-modal>
                        </div>

                        <!-- review_state: inReview|opened-->
                        <div v-if="quote.details.review_state == 'inReview' || quote.details.review_state == 'opened' || quote.details.review_state == 'updated'" class="review--state--opened">
                            <p>
                                <strong>&Egrave; il viaggio che cercavi?</strong>
                                <button-with-icon
                                    variant="cta" 
                                    text="Clicca e scopri come prenotare"
                                    :icon="chevron_right" 
                                    :disabled="!can_submit" 
                                    :clicked="() => { 
                                        $emit('send_to_api', {})
                                    }" 
                                />
                                <br>
                                <strong>Non è il viaggio che cercavi?</strong>
                                <button-with-icon
                                    variant="cta" 
                                    text="Richiedi modifiche a questa proposta" 
                                    :icon="chevron_right" 
                                    :disabled="!can_submit" 
                                    :clicked="() => {
                                    // $emit('send_to_api', { user_changes_request: 'richieste utente' })
                                    this.$bvModal.show('edit-request-modal')
                                    }"
                                />

                                <b-modal id="edit-request-modal" title="Richiedi modifiche a questa proposta" size="lg" hide-footer>
                                    <b-form-group label="Le tue modifiche">
                                        <b-form-textarea
                                            ref="user_changes_request"
                                            id="user_changes_request"
                                            v-model="user_changes_request"
                                            placeholder="Indica come possiamo migliorare questa proposta"
                                        ></b-form-textarea>
                                    </b-form-group>
                                    <button-with-icon
                                        variant="cta" 
                                        text="Continua"
                                        :disabled="user_changes_request == ''"
                                        :icon="chevron_right" 
                                        :clicked="() => {
                                            this.$bvModal.hide('edit-request-modal')
                                            $emit('send_to_api', {
                                                user_changes_request: this.user_changes_request,
                                            })
                                        }"
                                    />                                
                                </b-modal>

                                <br><br>

                                <button-with-icon
                                    class="btn--light" 
                                    variant="light" 
                                    text="Per ora, grazie così." 
                                    :icon="chevron_right" 
                                    :disabled="!can_submit" 
                                    :clicked="() => {
                                    this.$bvModal.show('edit-deny-modal')
                                    }"
                                />

                                <b-modal id="edit-deny-modal" title="Vuoi indicarci il problema? Grazie" size="lg" hide-footer>
                                    <b-form-group>
                                        <b-form-radio 
                                            v-for="(option,index) in deny_options" v-bind:key="index"
                                            v-model="deny_option" name="deny-options" :value="index">
                                            {{ option }}
                                        </b-form-radio>
                                        <b-form-textarea
                                            class="mt-2 mb-2"
                                            v-if="deny_option == 'freetext'"
                                            ref="user_changes_request"
                                            id="user_changes_request"
                                            v-model="user_reject_note"
                                            placeholder="Dacci più informazioni..."
                                        ></b-form-textarea>
                                    </b-form-group>
                                    <div class="d-flex align-items-center">
                                        <button-with-icon
                                            variant="cta" 
                                            text="Invia"
                                            class="d-inline-flex m-auto"
                                            :disabled="deny_option == 'freetext' && user_reject_note == ''"
                                            :icon="chevron_right" 
                                            :clicked="() => {
                                                this.$bvModal.hide('edit-deny-modal')
                                                $emit('send_to_api', {
                                                    user_reject_note: deny_option == 'freetext' ? this.user_reject_note : this.deny_options[deny_option],
                                                })
                                            }"
                                        />       
                                    </div>                         
                                </b-modal>

                            </p>
                        </div>

                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import Bwi from '@/components/atoms/button-with-icon'
    import { user, users, bedding, airplane, bus, star, shield, checked, info } from '@/components/svg/common'
    import { chevron_right } from '@/components/svg/chevrons'
    export default {
        name: 'review-resume',
        components: {
            'button-with-icon': Bwi,
        },
        props:
        {
            review_steps: {
                type: Array,
            },
            opened: {
                type: Boolean,
                default: false,
            },
            completed: {
                type: Boolean,
                default: false,
            },
            dictionaries: {
              type: Object,
              default: () => {}
            },
            review_state: String,
        },
        created()
        {
            this.bedding = bedding
            this.airplane = airplane
            this.bus = bus
            this.star = star
            this.shield = shield
            this.user = user
            this.users = users
            this.checked = checked
            this.info = info
            this.chevron_right = chevron_right
        },
        computed: {
            loading: {
                get() {
                    return this.$store.state.loading
                },
            },
            quote: {
                get() {
                    return this.$store.state.quote
                },
            },
        },        
        data() {
            return {
                can_submit: true,
                user_changes_request: '',
                user_reject_note: '',
                deny_option: 0,
                deny_options: {
                    /*
                    0: 'Non so',
                    1: 'La proposta non mi soddisfa',
                    2: 'Ci voglio pensare',
                    3: 'Al momento non ho credito welfare',
                    freetext: 'Altre motivazioni',
                    */
                    0: 'La Proposta non mi soddisfa',
                    1: 'Ci devo pensare',
                    2: 'Al momento non ho credito welfare',
                    3: 'Non ho capito il processo di prenotazione',
                    4: 'Era solo una richiesta esplorativa',
                    5: 'Il prezzo non mi sembra conveniente',
                    freetext: 'Altro...',
                },
            }
        },
        mounted() {
        },
        methods:{

          iataAirportToName(iata_code){

            iata_code = iata_code.toUpperCase();
            if(!this.dictionaries.airports) return iata_code
            if(!this.dictionaries.airports[iata_code]) return iata_code
            return this.dictionaries.airports[iata_code].name

          },

        },
    }
</script>

<style lang="scss">
    #review-resume
    {
        .review--resume--item
        {
            margin-bottom:1rem;
            padding-bottom:1rem;
            &:not(:last-child)
            {
                border-bottom:1px solid #dedede;
            }
            &--service
            {
                display:flex;
                font-size: 14px;
                justify-content: space-between;
            }
            &--icon
            {
                width:36px;
                text-align: center;
                path
                {
                    stroke:$text;
                    fill:$text;
                }
            }
            &--content
            {
                padding-left:10px;
                color:$text;
                display:flex;
                flex-direction:column;
                font-weight: 400;
                flex:1;
                text-align: left;
            }
            &--price
            {
                flex:1;
                text-align: right;
            }
        }
        .review--resume--total
        {
            display:flex;
            align-items: center;
            justify-content: space-between;
            background:$green;
            color:$white;
            font-size: 16px;
            font-weight: bold;
            padding:$grid-gutter-width/4 $grid-gutter-width/2;
            border-radius: $border-radius-sm;
        }
        .review--block--footer
        {
            .bwi
            {
                margin-top:1rem;
                margin-bottom:1rem;
                &:last-child
                {
                    margin-bottom:2.5rem;
                }
            }
            @include media-breakpoint-up(md)
            {
                padding-top:0;
            }
        }
        .review--state
        {
            strong
            {
                color:$tertiary;
                display: block;
                margin-bottom:0.75rem;
            }
            max-width:480px;
            margin:0 auto;
            //&--opened, -> no: lasciare com'è
            &--expired,
            &--declined,
            &--rejected,
            &--accepted
            {
                @extend .review--state;
            }

            &--opened
            {
                strong
                {
                    color:$black;
                }
            }
        }
    }
</style>